<template>
<section id="forgot">
    <NavbarDefault route="/" />
    <div class="container d-flex align-items-center justify-content-center width-880">
        <div class="row d-flex align-items-center justify-content-center">
            <div class="col-7">
                <h2 :class="`text-center c-${getPrimaryColor}four bold`">Crie sua senha</h2>
                <p class="c-ndarkfour text-center mb-4">
                    Crie agora a senha que você usará para acessar sua conta<br> {{ getWhiteLabel | capitalizeFirstLetter }} posteriormente.
                </p>
                <el-form :model="newPassword" ref="newPassword" @submit.native.prevent="createNewPassword">

                    <el-form-item prop="password" class="mb-4">
                        <!-- <InputText :class="isSuccess" type="password" v-model="newPassword.password" label="Senha" placeholder="Sua senha" show-password @keydown.space.native.prevent/> -->
                        <h6 class="regular" :class="isSuccess">
                            Senha
                        </h6>
                        <el-input :class="`${getPrimaryColor} isSuccess`" placeholder="Sua senha" native-type="password" v-model="newPassword.password" show-password @keydown.space.native.prevent />
                        <h6 class="mt-1 password-strength-label regular" :class="
                                //this.checkPassword.passwordStrength > 3 ? 'c-green' :
                                //this.checkPassword.passwordStrength > 1  ? 'Média': 'c-error'
                                this.checkPassword.passwordStrength > 3 ? 'c-green' : 'c-error'
                            ">
                            Força da senha:
                            {{
                                this.checkPassword.passwordStrength > 3 ? 'Forte' : 'Fraco'
                            }}
                        </h6>
                    </el-form-item>

                    <div class="row mb-4">
                        <div class="col-12 mb-2">
                            <p class="c-ndarkfour medium">
                                Sua senha deve ter:
                            </p>
                        </div>
                        <div class="col-6">
                            <p class="regular">
                                <check-icon class="c-green" v-show="checkPassword.sixSuccess"></check-icon>
                                <x-icon class="c-error" v-show="!checkPassword.sixSuccess"></x-icon>
                                Mínimo de 6 caracteres;
                            </p>
                        </div>
                        <div class="col-6">
                            <p class="regular">
                                <check-icon class="c-green" v-show="checkPassword.numberSuccess"></check-icon>
                                <x-icon class="c-error" v-show="!checkPassword.numberSuccess"></x-icon>
                                1 número;
                            </p>
                        </div>
                        <div class="col-6">
                            <p class="regular">
                                <check-icon class="c-green" v-show="checkPassword.upperSuccess"></check-icon>
                                <x-icon class="c-error" v-show="!checkPassword.upperSuccess"></x-icon>
                                1 letra maiúscula;
                            </p>
                        </div>
                        <div class="col-6">
                            <p class="regular">
                                <check-icon class="c-green" v-show="checkPassword.especialSuccess"></check-icon>
                                <x-icon class="c-error" v-show="!checkPassword.especialSuccess"></x-icon>
                                1 caractere especial.
                            </p>
                        </div>
                    </div>

                    <Button @click="createNewPassword" class="btn btn-blue w-100 justify-content-center" :disabled="!checkedPassword" :color="getPrimaryColor">
                        Confirmar
                    </Button>

                </el-form>
            </div>
        </div>
    </div>
    <FullLoading :color="getPrimaryColorHex.five" v-show="$store.state.user.loading" />
    <Footer />
</section>
</template>

<script>
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault'
import validatePassword from '@/utils/validatePassword'
import Footer from '@/components/navigation/footer/Footer'
import FullLoading from '@/components/loading/FullLoading'
import updateForgotPassword from '@/api/updateForgotPassword'
import {
    XIcon,
    CheckIcon,
} from 'vue-feather-icons';
import getPartner from '@/utils/getPartner'

export default {
    components: {
        NavbarDefault,
        XIcon,
        CheckIcon,
        Footer,
        FullLoading
    },
    data() {
        return {
            newPassword: {
                password: '',
                partner: '',
            }
        }

    },
    methods: {
        async createNewPassword() {
            const result = await updateForgotPassword(this.newPassword, this.$route.params.token)
            if (result.status == 200 && result.data.ok) this.$router.push('/forgot/password/success')
        }
    },
    computed: {
        checkPassword: function () {
            return validatePassword(this.newPassword.password)
        },
        checkedPassword: function () {
            return this.checkPassword.sixSuccess && this.checkPassword.numberSuccess && this.checkPassword.upperSuccess && this.checkPassword.especialSuccess
        },
        isSuccess: function () {
            return this.checkedPassword ? 'is-success' : 'is-error'
        }
    },
    async created(){
        this.newPassword.partner = await getPartner(this.getWhiteLabel)
    },
}
</script>

<style scoped>
.password-strength-label{
    font-weight: 400;
}

.width-880{
    max-width:880px;
}

</style>
